import { Form, Input, Modal, Select, message } from "antd";
import { AktDatePicker } from "components/aktDatePicker";
import {
  useUpdateDebtorMilitaryMutation,
  useCreateDebtorMilitaryMutation,
} from "features/military/militaryAPI";
import { useFetchBackendConstantsQuery } from "features/home/agencyPortal/homeAPI";
import styled from "styled-components";

const StyledForm = styled(Form)`
  margin-top: 12px;
  max-width: 400px;
`;

function AddMilitaryModal({ militaryRecord, debtorId, title, open, onOk, onCancel }) {
  const { data: constants } = useFetchBackendConstantsQuery();
  const [updateMilitary] = useUpdateDebtorMilitaryMutation();
  const [createMilitary] = useCreateDebtorMilitaryMutation();
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (militaryRecord) {
        await updateMilitary({ debtorId, militaryId: militaryRecord.id, ...values });
      } else {
        await createMilitary({ debtorId, ...values });
      }
      message.success("Military record saved successfully!");
      form.resetFields();
      onOk();
    } catch (error) {
      message.error("An error occurred. Please try again.");
    }
  };

  // See https://ant.design/components/form/ `validateMessages` to see how to customize error
  // messages.
  const validateMessages = {
    required: "This is a required field",
  };

  return (
    <Modal maskClosable={false} title={title} open={open} onOk={handleOk} onCancel={onCancel}>
      <StyledForm
        layout="vertical"
        form={form}
        autoComplete="off"
        validateMessages={validateMessages}
        initialValues={militaryRecord}
      >
        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: "Please select a status" }]}
        >
          <Select
            showSearch
            filterOption={(input, option) =>
              (option.label.toString() ?? "").toLowerCase().includes(input.toLowerCase())
            }
            popupMatchSelectWidth={false}
            placeholder="Select status..."
            options={constants?.debtorMilitaryStatuses?.map((each) => ({
              label: each.display,
              value: each.value,
            }))}
          />
        </Form.Item>
        <Form.Item label="Service Branch" name="serviceBranchDescription">
          <Input placeholder="Enter service branch (e.g., Army, Navy, Air Force)..." />
        </Form.Item>
        <Form.Item
          label="Active Duty Start Date"
          name="activeDutyStartDate"
          dependencies={["activeDutyEndDate"]}
        >
          <AktDatePicker
            disabledDate={(current) => {
              const endDate = form.getFieldValue("activeDutyEndDate");
              if (endDate) {
                return current && current > new Date(endDate);
              }
              return false;
            }}
          />
        </Form.Item>
        <Form.Item
          label="Active Duty End Date"
          name="activeDutyEndDate"
          dependencies={["activeDutyStartDate"]}
        >
          <AktDatePicker
            disabledDate={(current) => {
              const startDate = form.getFieldValue("activeDutyStartDate");
              if (startDate) {
                return current && current <= new Date(startDate);
              }
              return false;
            }}
          />
        </Form.Item>
        <Form.Item label="Scrub Date" name="scrubDate">
          <AktDatePicker />
        </Form.Item>
        <Form.Item label="Certificate ID" name="certificateId">
          <Input placeholder="Enter certificate ID..." />
        </Form.Item>
      </StyledForm>
    </Modal>
  );
}

export default AddMilitaryModal;
